import { type AllowedMaterialSpec } from 'api';
import {
  AllowedMaterialSpecAutocomplete,
  CountryAutocompleteField,
  MaterialGradeAutocomplete,
  MaterialSupportedComponentAutocomplete,
  useFormContext,
} from 'form';
import { useTranslation } from 'i18n';
import { useState } from 'react';
import { Stack } from 'ui';

export const MaterialProductsListFilters = () => {
  const { t } = useTranslation('orders');
  const form = useFormContext();
  const [materialSpec, setMaterialSpec] = useState<AllowedMaterialSpec | undefined>(undefined);

  const onMaterialSpecChange = (materialSpec: AllowedMaterialSpec) => {
    setMaterialSpec(materialSpec);
    form.setValue('material_supported_component_id', undefined);
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        marginBottom: 2,
      }}
    >
      <CountryAutocompleteField label={t('materialProducts.filters.labels.country')} name="country" />
      <AllowedMaterialSpecAutocomplete
        label={t('materialProducts.filters.labels.materialSpec')}
        name="material_spec_id"
        onSelectOption={onMaterialSpecChange}
      />
      <MaterialGradeAutocomplete label={t('materialProducts.filters.labels.materialGrade')} name="material_grade_id" />
      <MaterialSupportedComponentAutocomplete
        label={t('materialProducts.filters.labels.materialQuality')}
        name="material_supported_component_id"
        materialId={materialSpec?.material_id}
        materialColourId={materialSpec?.colour_id || undefined}
        disabled={!materialSpec}
      />
    </Stack>
  );
};
